import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getClientSnapshotsList } from '../actions/api'
import { setShowClientHistory, setClientSnapshotList, setClientModifyingDateTimeArray, setClientSelectedSnapshotIndex, setCurrentClientState } from '../actions/localStates'

import { formatDateForCalendar } from '../actions/helpers'

import ClientHistoryView from '../components/ClientHistoryView'

class ClientHistoryContainer extends Component {

	constructor(props) {
        super(props);

        this.state = {
        }
    }

	componentDidMount() {
        var dateArray = [], _this = this, urlString = "?page=0&size=20&sort=modifyingDateTime,desc";
		this.props.actions.setShowClientHistory(true)
        var data = {
          "clientName": this.props.client.clientName, //"postman-user-173001"
          "modifyingDateTimeNotBefore": null,
          "modifyingDateTimeNotAfter": null,
          "modifyingInitiatorId": null,
          "operator": null
        }

        this.props.actions.getClientSnapshotsList(this.props.base.serviceUrl, this.props.login.accessToken, data, urlString)
        .then((response) => {
            console.log(response)

            if (response.contentType !== undefined && response.contentType !== "application/ccs.api.error+json;charset=UTF-8") {
                this.props.actions.setErrorResponse(response.json)
                this.setState({showErrorPopup: true})
                return
            }

            if (response.content.length > 0) {
                if (response.content.length < response.page.totalElements) {
                    urlString = "?page=0&size=" + response.page.totalElements + "&sort=modifyingDateTime,desc"
                } else {
                    urlString = "?page=0&size=20&sort=modifyingDateTime,desc"
                }

                this.props.actions.getClientSnapshotsList(this.props.base.serviceUrl, this.props.login.accessToken, data, urlString)
                .then((response) => {
                    if (response.contentType !== undefined && response.contentType !== "application/ccs.api.error+json;charset=UTF-8") {
                        this.props.actions.setErrorResponse(response.json)
                        this.setState({showErrorPopup: true})
                        return
                    }

                    this.props.actions.setCurrentClientState(null)
                    this.props.actions.setClientSnapshotList(response.content)
                    response.content.forEach((element) => {
                        dateArray.push(_this.props.actions.formatDateForCalendar(element.modifyingDateTime))
                    })

                    var enquire = JSON.parse(response.content[0].clientJson)
                    // this.props.actions.clearTokenEnquire()
                    window.setTimeout(function () {
                        _this.props.actions.setCurrentClientState(enquire)
                    }, 25)
                    this.props.actions.setClientSelectedSnapshotIndex(0)

                    this.props.actions.setClientModifyingDateTimeArray(dateArray)
                })
                
            } else {
                this.props.actions.setCurrentClientState(null)
                this.props.actions.setClientSnapshotList([])
                this.props.actions.setClientSelectedSnapshotIndex(0)
                this.props.actions.setClientModifyingDateTimeArray([])
            }
        })
	}

	render() {
		return (
			<ClientHistoryView />
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        client: state.clientReducer,
        login: state.loginReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
        setShowClientHistory, getClientSnapshotsList,
        setClientSnapshotList, setClientModifyingDateTimeArray, setClientSelectedSnapshotIndex,
        setCurrentClientState, formatDateForCalendar
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientHistoryContainer);